<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :filterItems="filterItems"
      :get-data-func="getGroups"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      selectable
      title-text="分组列表"
      v-model="selected"
      search-text="搜索分组名称"
    >
      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="deleteGroup(item)" icon>
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <!--<v-layout>
      <v-flex class="pt-3" sm4 xs12>
        <l-action-card
          @click="goGroupType()"
          icon="$vuetify.icons.group"
          label="管理分组类型"
        ></l-action-card>
      </v-flex>
    </v-layout>-->
    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'
import LActionCard from '../../../components/LActionCard'
import defaults from '../../../consts'
export default {
  name: 'GroupList',
  components: {LActionCard},
  props: ['refresh'],
  data: () => ({
    selected: [],
    floatingButton: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'bindGroup',
      //   label: '批量绑定分组类型',
      //   icon: '$vuetify.icons.group'
      // },
      // {
      //   event: 'bindRole',
      //   label: '批量绑定角色',
      //   icon: '$vuetify.icons.role'
      // },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: defaults.userAdmin.GROUP_ACTION_HEADERS,
  }),
  computed: {
    groupTypes () {
      return this.$store.state.userAdmin.groupTypes
    },
    filterItems () {
      return [
        {
          prependIcon: '$vuetify.icons.group',
          key: 'type',
          value: '',
          label: '用户分组类型',
          type: 'select',
          layout: ['xs12', 'sm4'],
          items: this.groupTypes,
          itemText: 'description',
          itemValue: 'name',
          noDataText: '没有数据'
        },
        {
          key: 'creationTime',
          value: {},
          label: '创建时间',
          type: 'duration',
          layout: ['xs12', 'sm8'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
      /*  {
          prependIcon: '$vuetify.icons.level',
          key: 'level',
          value: '',
          label: '分组级别',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.levelCode',
          key: 'code',
          value: '',
          label: '分组代码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },*/
      ]
    }
  },
  watch: {
    groupTypes (val) {
      if (!val.length) {
        this.getGroupTypes()
      }
    }
  },
  methods: {
    async getGroupTypes () {
      try {
        await this.$store.dispatch('userAdmin/getGroupTypes', {
          pagination: {page: 1, rowsPerPage: 100, sortBy: 'name'},
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    async getGroups ({pagination, sortStack, filterItems, search}) {
      let type = filterItems.find(f => f.key === 'type')
      console.log('getGroups', type, filterItems)
      return this.$store.dispatch('userAdmin/getGroups', {
        pagination,
        sortStack,
        filter: filterItems.filter(f => f.key !== 'type'),
        search: {key: 'name', value: search},
        type: type ? type.value : undefined
      })
    },
    async deleteGroup (org) {
      // console.log(user)
      if (!org) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该分组？',
        text: org.name || `N/A`,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteGroups', [org])
          this.$refs.dataTable.refresh()
          this.$L.alert('success', {message: '删除成功'})
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    goDetails (item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'GroupDetails',
          params: {name: item.name},
          query: {id: item.id}
        })
      }
    },
    goGroupType () {
      this.$router.push({
        name: 'GroupTypeList'
      })
    },
    goNew () {
      this.$router.push({
        name: 'NewGroup'
      })
    }
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  },
  created () {
    this.getGroupTypes()
  }
}
</script>

<style scoped>

</style>
